import { useEffect, useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ProductGrid from '../components/product/ProductGrid';
import { useOffers } from '../context/OffersContext';
import { useMarket } from '../context/MarketContext';
import { getAllProducts } from '../services/productService';
import { offerCoversProduct, offerHowItWorks } from '../utils/offerMatch';

/** /offers/:code — every product in an automatic offer. */
const OfferPage = () => {
  const { code } = useParams();
  const { offers, sym } = useOffers();
  const { currentMarket } = useMarket();
  const marketCode = currentMarket?.isDefault ? null : (currentMarket?.code ?? null);
  const [catalog, setCatalog] = useState(null);

  useEffect(() => {
    let alive = true;
    getAllProducts({ marketCode }).then((list) => { if (alive) setCatalog(list || []); }).catch(() => { if (alive) setCatalog([]); });
    return () => { alive = false; };
  }, [marketCode]);

  const offer = offers.find((o) => o.code === code);
  const products = useMemo(() => (offer && catalog ? catalog.filter((p) => offerCoversProduct(offer, p)) : []), [offer, catalog]);

  return (
    <>
      <Helmet><title>{offer ? `${offer.title} — Skinn Thrive` : 'Offer — Skinn Thrive'}</title></Helmet>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        {offer ? (
          <>
            <p className="section-tag">Offer</p>
            <h1 className="text-2xl md:text-3xl font-bold text-ink mt-2">{offer.title}</h1>
            <p className="text-ink-soft mt-2 max-w-2xl">{offerHowItWorks(offer, sym)}</p>
            <div className="mt-8">
              <ProductGrid products={products} loading={catalog === null} emptyMessage="No products in this offer right now." />
            </div>
          </>
        ) : (
          <div className="text-center py-20">
            <p className="text-2xl font-bold text-ink mb-2">This offer has ended</p>
            <Link to="/shop" className="text-sm font-semibold text-primary hover:underline">Shop all products</Link>
          </div>
        )}
      </div>
    </>
  );
};

export default OfferPage;
